export enum Status {
  Approved = 1, // booking (old system status: Odobrena = 1)
  Cancelled = 2, // booking (old system status: Otkazana = 2)
  Processing = 3, // booking (old system status: Obrada = 3)
  Completed = 4, // booking (old system status: Realizovana = 4)
  AutoCompleted = 5, // booking (old system status: Autorealizovana = 5)
}
